"use client";

import { Drawer, DrawerContent, DrawerTitle } from "@/components/ui/drawer";
import type { MusicSong } from "@/lib/music/types";
import { uiHaptics } from "@/lib/ui-haptics";
import { MusicBrowser } from "./music-browser";

/**
 * Pick ONE song — for a post, a chat message, an event or experience banner.
 * Tapping + picks it and closes; every row previews first.
 */
export function SongPickerDrawer({
  open,
  onOpenChange,
  onPick,
  selectedSongId = null,
  title = "Add music",
  subtitle = "Tap a song to preview",
  nested = false,
  layer,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onPick: (song: MusicSong) => void;
  selectedSongId?: string | null;
  title?: string;
  subtitle?: string;
  /** Opened from inside another drawer (a composer, a sheet). */
  nested?: boolean;
  layer?: number;
}) {
  return (
    <Drawer
      open={open}
      onOpenChange={onOpenChange}
      nested={nested}
      repositionInputs={false}
    >
      <DrawerContent
        layer={layer}
        className="mx-auto h-[calc(88dvh-env(safe-area-inset-top))] max-w-2xl pb-[env(safe-area-inset-bottom)] data-[vaul-drawer-direction=bottom]:rounded-t-3xl"
      >
        <DrawerTitle className="sr-only">{title}</DrawerTitle>
        <MusicBrowser
          open={open}
          title={title}
          subtitle={subtitle}
          isSelected={(id) => id === selectedSongId}
          onSelect={(song) => {
            uiHaptics.select();
            onPick(song);
            onOpenChange(false);
          }}
          previewSurface="picker"
        />
      </DrawerContent>
    </Drawer>
  );
}
